const readString = (value: unknown, fallback: string): string =>
  typeof value === 'string' && value.length > 0 ? value : fallback

export type RefreshTransport = 'body' | 'cookie'

export const useMocks: boolean = __USE_MOCKS__

export const apiBaseUrl: string = readString(import.meta.env.VITE_API_BASE_URL, '/api/v1')

export const csrfCookieName: string = readString(
  import.meta.env.VITE_CSRF_COOKIE_NAME,
  'partner_space_csrf',
)

export const refreshTransport: RefreshTransport =
  readString(import.meta.env.VITE_REFRESH_TRANSPORT, 'body') === 'cookie' ? 'cookie' : 'body'
